import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axios";

// const SUPPORTED_LANGS = new Set(["en", "ru", "zh"]);
// const normalizeLang = (value) => {
//   if (value === undefined || value === null) return undefined;
//   const v = String(value).trim();
//   return SUPPORTED_LANGS.has(v) ? v : "ru";
// };

const FORCED_LANG = "ru";

export const updateUser = createAsyncThunk(
  "user/updateUser",
  // async ({ telegramId, firstName, phone, languageCode }, thunkAPI) => {
    async ({ telegramId, firstName, phone }, thunkAPI) => {
    try {
      const payload = {};

      if (firstName !== undefined) payload.firstName = firstName;
      if (phone !== undefined) payload.phone = phone;

      // const lang = normalizeLang(languageCode);
      // if (lang !== undefined) payload.languageCode = lang;

      payload.languageCode = FORCED_LANG;

      await axios.post(`/api/user/${telegramId}`, payload);

      return payload; 
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err?.response?.data?.message || err?.message || "Update user failed"
      );
    }
  }
);

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      // Force RU even if Telegram/DB provides another language.
      if (!action.payload) {
        state.data = action.payload;
        return;
      }
      state.data = {
        ...action.payload,
        languageCode: FORCED_LANG,
      };
    },
    clearUser(state) {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = {
          ...state.data,
          ...action.payload, 
        };
        if (state.data) state.data.languageCode = FORCED_LANG;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || action.error?.message || "Update user failed";
      });
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
